interface VideoAspectRatios {
    "16x9": string;
    "9x16": string;
}

export const VIDEO_ASPECT_RATIOS: VideoAspectRatios = Object.freeze({
    "16x9": "16:9",
    "9x16": "9:16",
});
